import React, { useRef, useEffect, useImperativeHandle, useState } from 'react';
import styles from './styles.less';

const Player = React.forwardRef((props, ref) => {
  const playerContainerRef = useRef();
  const [player, setPlayer] = useState(null);
  const { url, defaultMute } = props;

  useImperativeHandle(ref, () => ({
    pause: () => {
      player.pause();
    },
    play: (url) => {
      player.play(url);
    },
    screenshot: (cb) => {
      player.$canvasElement.toBlob(cb, 'image/jpeg', 1);
    },
    mute: () => {
      player.mute();
    },
    cancelMute: () => {
      player.cancelMute();
    },
    setRotate: (deg) => {
      player.setRotate(deg);
    },
    resize: () => {
      player.resize();
    },
  }));

  useEffect(() => {
    let timer;
    const player = new window.Jessibuca({
      container: playerContainerRef.current,
      decoder: './index.js',
      videoBuffer: 0.2,
      isNotMute: defaultMute === undefined ? true : !defaultMute,
      debug: false,
      isResize: false,
    });

    setPlayer(player);

    if (url) {
      player.onLoad = function () {
        player.play(url);
      };

      player.on('stats', function (s) {
        // console.log('stats is', s);
      });

      player.onError = function () {
        // console.log('播放异常 1.5秒后发起重新播放');
        timer = setTimeout(() => {
          // console.log('重新播放', url);
          player.play(url);
        }, 1500);
      };
    }

    return () => {
      clearTimeout(timer);
      if (player) {
        player.destroy();
      }
    };
  }, [url]);

  return <div className={styles.playBox} ref={playerContainerRef}></div>;
});

export default Player;
